import { Upload } from "antd";

const { Dragger } = Upload;

export { Dragger };
